// Keep navigation and collection popovers dismissible by pointer and keyboard.
const disclosureSelector = 'details[data-disclosure]';
document.addEventListener('toggle', (event) => {
  const disclosure = event.target;
  if (!disclosure.matches(disclosureSelector)) return;
  if (disclosure.classList.contains('br-mobile-menu')) {
    disclosure.querySelector('summary').setAttribute('aria-label', disclosure.open ? 'Close navigation' : 'Open navigation');
  }
  if (disclosure.open) {
    document.querySelectorAll(disclosureSelector).forEach((other) => {
      if (other !== disclosure) other.open = false;
    });
  }
}, true);
document.addEventListener('click', (event) => {
  document.querySelectorAll(`${disclosureSelector}[open]`).forEach((disclosure) => {
    if (!disclosure.contains(event.target)) disclosure.open = false;
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll(`${disclosureSelector}[open]`).forEach((disclosure) => {
    disclosure.open = false;
    disclosure.querySelector('summary').focus();
  });
});

// Keep navigation focus inside the open panel, including its close control.
const shopMenu = document.querySelector('.br-shop-menu');
if (shopMenu) {
  const panel = shopMenu.querySelector('.br-shop-panel');
  const trigger = shopMenu.querySelector('summary');
  panel.setAttribute('role', 'dialog');
  panel.setAttribute('aria-modal', 'true');
  const closeMenu = () => { shopMenu.open = false; trigger.focus(); };
  shopMenu.addEventListener('toggle', () => {
    document.body.classList.toggle('br-navigation-open', shopMenu.open);
    trigger.setAttribute('aria-expanded', String(shopMenu.open));
    if (shopMenu.open) panel.querySelector('button').focus();
  });
  shopMenu.querySelectorAll('[data-menu-close]').forEach(control => control.addEventListener('click', closeMenu));
  shopMenu.addEventListener('keydown', event => {
    if (!shopMenu.open || event.key !== 'Tab') return;
    const controls = [...panel.querySelectorAll('a[href],button,input:not([type=hidden])')].filter(el => el.getClientRects().length);
    const first = controls[0], last = controls[controls.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === trigger)) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  // Closing on a breakpoint change avoids an off-screen focused control.
  matchMedia('(max-width:989px)').addEventListener('change', () => { if (shopMenu.open) closeMenu(); });
}
